export { default } from './InfoModal';
export { default as InfoModal } from './InfoModal';
